import React, {useContext, useState, useRef, useMemo, useEffect} from 'react';
import { useDispatch, useSelector } from "react-redux";

import './SaveTemplateModal.scss';

import UniversalButton from "../../uiComponents/UniversalButton";

import {ModalContext} from "../../ModalContext";
import {
  getTemplateQuickInfo,
  addTemplateFolder, deleteTemplateFolder
} from "../../../utils/builder/IScheduleLogic";
import {addFolderTemplate, addTemplate, deleteFolderTemplate, templateEdit} from "../../../store/actions/template";
import DropDownFolder from "../../uiComponents/DropDownFolder";
import {showToast} from "../../../utils/helpers";

const SaveTemplateModal = ({filterState, closeEditTemplate, type="create", folderInfo=null}) => {

  const template = {
    folder: folderInfo?.folderName  || "Default",
    template: folderInfo?.templateName || "",
    description: ""
  }

  useEffect(() => {
    if(type === "edit") {
      getTemplateQuickInfo(folderInfo.templateName, folderInfo.folderName)
        .then((res)=> setInfoAboutTemplate({...infoAboutTemplate, description: res.descreption }));
    }
  }, []);

  const dispatch = useDispatch();
  const { templatesFolder } = useSelector((state) => state.viewer);

  const schemesForTabs = useSelector((state) => state.tabsSettings.tabsSettings);
  const reportTabSchemesMenuData = schemesForTabs?.[1] ?? {}

  const [infoAboutTemplate, setInfoAboutTemplate] = useState(template);
  const [nameError, setNameError] = useState(null);

  const { handleModal } = useContext(ModalContext);
  const name = useRef();
  const description = useRef();

  const folders = useMemo(() => {
    const folders = Object.keys(templatesFolder);
    return folders;
  }, [templatesFolder]);

  const handleCancel = () => {
    handleModal(null, true);
  };

  const getSelectGroup = (groupName)=> {
    setFolderName(groupName);
  }

  const saveAsTemplate = async () => {
    const { folder, template, description } = infoAboutTemplate;
    const { properties, group } = filterState;

    const {columnSchemes = null, colorScheme = null} = reportTabSchemesMenuData

    const haveError = checkValidation();

    if(haveError) {
      try {
        await dispatch(addTemplate({folder, template, description, properties, group, columnSchemes, colorScheme}));
        showToast(true,"Template was created");
      } catch (error) {
        showToast(false, error);
      }
      handleCancel();
    }
  }

  const handleEditTemplate = async () => {
    const { folder: newNameFolder, template: newNameTemplate, description: newDescriptionTemplate } = infoAboutTemplate;
    const { folderName: currentNameFolder, templateName: currentNameTemplate } = folderInfo;

    const haveError = checkValidation();

    if(haveError) {
      try {
        await dispatch(templateEdit({currentNameFolder, currentNameTemplate, newNameFolder, newNameTemplate, newDescriptionTemplate}));
        showToast(true,"Template was edited");
      } catch (error) {
        showToast(false, error);
      }
      closeEditTemplate();
    }
  }

  const checkValidation = () => {
    const templateName = infoAboutTemplate.template;
    const folder = infoAboutTemplate.folder;
    const isExistName = templatesFolder[folder].includes(templateName);

    if(!templateName) {
      setNameError("The template name cannot be empty");
      return false;
    }
    if (isExistName && type === "create") {
      setNameError("This name already exists");
      return false;
    }

    return true;
  }

  const addFolder = async (folderName) => {
    try {
      dispatch(addFolderTemplate(folderName));
      setFolderName(folderName);
      showToast(true,"Folder template was created");
    } catch (error) {
      showToast(false, error);
    }
  }

  const setTemplateName = (name) => {
    setInfoAboutTemplate({...infoAboutTemplate, template: name });
  }

  const setDescriptionName = (name) => {
    setInfoAboutTemplate({...infoAboutTemplate, description: name });
  }

  const setFolderName = (name) => {
    setInfoAboutTemplate({...infoAboutTemplate, folder: name });
  }

  return (
    <div className="save-template">
      <div className="save-template__header">{`${type === "create" ? "Save" : "Edit"} search template`}</div>
      <div className="save-template__name">
        <label htmlFor="save-template__name">Template name</label>
        <input id="save-template__name"
               className={nameError ? "save-template__input-error" : ""}
               type="text" ref={name}
               value={infoAboutTemplate.template}
               onInput={(event) => setTemplateName(event.target.value)}/>
        {
          nameError ? <div className="save-template__error-text">{nameError}</div> : null
        }
      </div>
      <div className="save-template__description">
        <label htmlFor="save-template__description">
          Description <span className="save-template__description_gray">(optional)</span>
        </label>
        <textarea id="save-template__description" rows="3" ref={description}
                  value={infoAboutTemplate.description}
                  onInput={(event) => setDescriptionName(event.target.value)}>
        </textarea>
      </div>
      <div className="save-template__group">
        <DropDownFolder listTitle={infoAboutTemplate.folder} list={folders} getSelectFolder={getSelectGroup} addFolder={addFolder}/>
      </div>
      <div className="save-template__btns">
        <div className="save-template__btns_btn">
          <UniversalButton
            type="button"
            label="Cancel"
            size="lg"
            labelColor="blue"
            labelHoverColor="blue"
            backgroundColor="white"
            backgroundHoverColor="blue-light"
            onClick={type === "create" ? handleCancel : closeEditTemplate}
          />
        </div>

        <UniversalButton
          type="button"
          label="Save"
          size="lg"
          labelColor="white"
          labelHoverColor="white"
          backgroundColor="orange"
          backgroundHoverColor="orange-light"
          onClick={type === "create" ? saveAsTemplate : handleEditTemplate}
        />
      </div>
    </div>
  );
};

export default SaveTemplateModal;